import { render } from "./CecoForm.vue?vue&type=template&id=00c96e71&scoped=true"
import script from "./CecoForm.vue?vue&type=script&lang=js"
export * from "./CecoForm.vue?vue&type=script&lang=js"

import "./CecoForm.vue?vue&type=style&index=0&id=00c96e71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c96e71"]])

export default __exports__